<template>
  <SlotBanner
    class="spring-banner"
    :start="springPromoDateRange.startDate.toISOString()"
    :finish="springPromoDateRange.endDate.toISOString()"
    @start="$emit('start')"
    @finish="$emit('finish')"
  >
    <div class="spring-banner__inner">
      <div class="spring-banner__bg spring-banner__bg--left" />
      <div class="spring-banner__bg spring-banner__bg--right" />
      <img
        src="@/assets/images/springPromo/cake.webp"
        class="spring-banner__img spring-banner__img--left"
        alt="spring banner image"
        width="132"
        height="73"
      />
      <div class="spring-banner__container">
        <div class="spring-banner__text-content">
          <div class="spring-banner__text-block">
            <div class="spring-banner__title">ANY.RUN is 9!</div>
            <div class="spring-banner__text-wrapper">
              <div class="spring-banner__date">May 19 - May 31</div>
              <div class="spring-banner__sub-title">
                Celebrate with us and grab your gift 🎉
              </div>
            </div>
          </div>

          <a
            href="https://app.any.run/plans"
            target="_blank"
            class="spring-banner__link"
          >
            See all offers
          </a>
        </div>
      </div>

      <img
        src="@/assets/images/springPromo/gift-banner.webp"
        class="spring-banner__img spring-banner__img--right"
        alt="spring banner image"
        width="132"
        height="73"
      />
    </div>
  </SlotBanner>
</template>

<script setup>
import SlotBanner from './SlotBanner.vue';
import { springPromoDateRange } from '@/shared/utils/springPromo';
</script>

<style lang="scss" scoped>
.spring-banner {
  position: relative;
  overflow: hidden;
  background-color: #0d2439 !important;
}

.spring-banner__inner {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  width: 100%;
  max-width: 1460px;
  height: 100%;
  margin: 0 auto;

  @media (min-width: 320px) and (max-width: 379px) {
    padding: 10px;
  }
  @media (min-width: 380px) and (max-width: 768px) {
    padding: 14px;
  }
}

.spring-banner__bg {
  position: absolute;
  width: 250px;
  height: 234px;
  pointer-events: none;
  z-index: 0;
}

.spring-banner__bg--left {
  left: 0;
  top: 50%;
  transform: translateY(-50%) translateX(-20%);
  background: url('@/assets/images/springPromo/left-light.svg') no-repeat center;

  @media (max-width: 767px) {
    transform: translateY(-50%) translateX(-60%);
  }

  @media (min-width: 768px) and (max-width: 979px) {
    transform: translateY(-50%) translateX(-50%);
  }

  @media (min-width: 1280px) {
    transform: none;
    left: 60.5px;
    top: unset;
  }
}

.spring-banner__bg--right {
  right: 0;
  top: 50%;
  transform: translateY(-50%) translateX(20%);
  background: url('@/assets/images/springPromo/right-light.svg') no-repeat
    center;

  @media (max-width: 767px) {
    transform: translateY(-50%) translateX(60%);
  }

  @media (min-width: 768px) and (max-width: 979px) {
    transform: translateY(-50%) translateX(50%);
  }

  @media (min-width: 1280px) {
    transform: none;
    right: 60.5px;
    top: unset;
  }
}

.spring-banner__container {
  position: relative;
  z-index: 1;
}

.spring-banner__link {
  padding: 9px 15px;
  background: linear-gradient(95.28deg, #f3551d 1.15%, #fdbc3e 109.28%);
  color: #ffffff;
  font-family: 'Montserrat';
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 2%;
  line-height: 24px;
  border-radius: 3px;
  width: 142px;
  height: 42px;

  @media (max-width: 379px) {
    font-size: 12px;
    padding: 6px 20px;
    width: 124px;
    height: 36px;
  }

  &:hover {
    background: linear-gradient(95deg, #f3551d 31.59%, #fdbc3e 141.95%);
    color: #ffffff !important;
  }
}

.spring-banner__title {
  font-family: 'Montserrat';
  font-weight: 900;
  line-height: 100%;
  font-size: 35px;
  text-transform: uppercase;
  background: linear-gradient(90deg, #ff5d29 0%, #ffd361 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-font-smoothing: subpixel-antialiased;
  background-clip: text;

  @media (max-width: 379px) {
    font-size: 18px;
  }

  @media (max-width: 979px) {
    font-size: 26px;
  }

  @media (min-width: 980px) {
    font-size: 35px;
  }

  @media (min-width: 1440px) {
    font-size: 43px;
  }
}

.spring-banner__img {
  position: absolute;
}

.spring-banner__img--right {
  position: absolute;
  left: 92%;
  top: 15%;

  @media (max-width: 767px) {
    display: none;
  }
  @media (min-width: 1280px) {
    right: 60.5px;
    left: auto;
  }
}

.spring-banner__img--left {
  right: 92%;
  top: 15%;

  @media (max-width: 767px) {
    display: none;
  }
  @media (min-width: 1280px) {
    left: 60.5px;
    right: auto;
  }
}

.spring-banner__text-content {
  display: flex;
  align-items: center;
  gap: 40px;

  @media (max-width: 768px) {
    gap: 20px;
  }
}

.spring-banner__text-block {
  display: flex;
  align-items: center;
  gap: 40px;
  width: max-content;
  text-rendering: geometricPrecision;

  @media (max-width: 980px) {
    flex-direction: column;
    gap: 5px;
    align-items: flex-start;
  }
}

.spring-banner__date {
  font-family: 'Montserrat';
  font-weight: 800;
  line-height: 100%;
  font-size: 23px;
  letter-spacing: 0%;
  text-transform: uppercase;
  text-align: left;
  color: #fff;
  margin-bottom: 8px;

  @media (max-width: 379px) {
    font-size: 16px;
  }

  @media (max-width: 979px) {
    font-size: 18px;
    margin-bottom: 0;
  }
}

.spring-banner__sub-title {
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #fff;

  @media (max-width: 980px) {
    display: none;
  }
}
</style>
